module.exports = __webpack_public_path__ + "static/media/seattle-skyline.e551efe5.png";